<!--
 * @Author: Antigravity
 * @Date: 2026-03-23
 * @Description: 游客分析-投诉渠道
-->

<template>
  <div class="w-full flex flex-col">
    <div class="w-full flex items-end justify-between my-16">
      <div class="text-16 font-bold text-black-primary">投诉渠道</div>
    </div>

    <div class="card flex flex-col p-16">
      <div v-if="loading" class="state-text">加载中...</div>
      <div v-else-if="!list.length" class="state-text">暂无数据</div>
      <div v-else class="flex flex-col gap-24">
        <div v-for="(item, index) in list" :key="index" class="flex items-start">
          <span class="channel-name">{{ item.name }}</span>
          <div class="flex-1 flex flex-col gap-8">
            <!-- 进度条容器 -->
            <div class="bg-[#EDF0F5] h-10 rounded-full overflow-hidden relative">
              <div 
                class="h-full rounded-full transition-all duration-500" 
                :style="{ width: getValidWidth(item.ratio), background: getBarColor(index, item.ratio) }"
              ></div>
            </div>
            <!-- 统计信息 -->
            <div 
              class="statistics-info"
              :class="{ 'text-empty': isDataEmpty(item.ratio) }"
            >
              <span class="mr-12">投诉量 {{ formatNumber(item.total) }}</span>
              <span>占比 {{ item.ratio }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import APIS from "@/service/modules/complaintApis/modules/visualization.js";
import visualFilterMixin from "../../mixins/visualFilterMixin";

export default {
  name: "ChannelCountCell",
  mixins: [visualFilterMixin],
  data() {
    return {
      loading: false,
      total: 0,
      list: []
    };
  },
  methods: {
    isDataEmpty(ratio) {
      return !ratio || ratio === '--%' || ratio === '--' || ratio === '0%';
    },
    getBarColor(index, ratio) {
      if (this.isDataEmpty(ratio)) return '#EDF0F5';
      const colors = ['#36B374', '#3A7FF0', '#7F66FF', '#FF8C19', '#F9B200', '#FF5B60'];
      return colors[index % colors.length];
    },
    getValidWidth(ratio) {
      if (!ratio || ratio === '--%' || ratio === '--') return '0%';
      return ratio;
    },
    formatNumber(n) {
      if (!n && n !== 0) return "--";
      return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    onLoad() {
      const { areaId, beginTime, endTime, rule, channel } = this.filterParams;
      const params = {
        cityId: areaId,
        startDate: beginTime,
        endDate: endTime,
        rule: rule,
        channel: channel
      };

      this.loading = true;
      APIS.getChannelCount(params).then(res => {
        if (res && res.ret === 0) {
          // 修正：接口返回的是数组直接作为 data
          this.list = Array.isArray(res.data) ? res.data : [];
        }
      }).finally(() => {
        this.loading = false;
      });
    }
  }
};
</script>

<style lang="less" scoped>
.card {
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.04);
}

.channel-item {
  width: 100%;
}

.channel-name {
  width: 64px;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  color: #333;
  text-align: right;
  flex-shrink: 0;
  margin-right: 16px;
}

.statistics-info {
  font-size: 14px;
  line-height: 20px;
  color: #1E2226;
}

.text-empty {
  color: #C0C4CC;
}

.state-text {
  width: 100%;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
  font-size: 14px;
}
</style>
